enum PaymentMethod {
  TRANSFER = 'transfer',
  DEBIT = 'debit',
  CREDIT = 'credit',
  CHECK = 'check',
  MONTHLY = 'monthly',
}

enum PaymentStatus {
  PENDING = 'pending',
  PAID = 'paid',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export {
  PaymentMethod,
  PaymentStatus,
};
